<template>
  <div class="cals box cals-classes" :class="step.uniClass">
    <div class="onboard-pill" v-if="isOnboarding">
          <span class="onboard-pill__status" :class="{'onboard-pill__status__done': step.done}">
            <span v-if="step.done" class="icon-checkmark4 js-setupWidgetEvent"></span>
          </span> {{ $t('vue2.dashboard.step') }} {{step.stepNum}}
    </div>
    <span v-if="step.icon" class="cals_icon" :class="step.icon"></span>
    <spinner v-if="step.stepNum < 6 && isLoading" color="blue" size="small" style="margin-top:30px"></spinner>
    <h6 v-if="step.number >= 0 && !isLoading">{{step.number}}</h6>
    <h5>{{step.title}}</h5>
    <p v-if="step.desc && isOnboarding" class="step-desc">{{step.desc}}</p>
    <template v-if="!isOnboarding">
      <button v-if="step.buttonText" class="bttn submit-button" @click="step.action">
        {{step.buttonText}}
      </button>
      <button v-if="!isSchoolFromNorway" @click="seeTutorial(step)" class="bttn bttn-simple youtube-popup">
        <span class="icon-play3"></span> {{ $t('vue2.dashboard.tutorial') }} ({{step.guideDuration}})
      </button>
    </template>
  </div>
</template>

<script>
  import spinner from '../common/Spinner'
  import eventbus from '../../eventbus'

  export default {
    components: {spinner},
    props: {
      isOnboarding: {
        type: Boolean,
        default: false
      },
      step: {
        default: {
          title: 'Classes',
          icon: 'icon-calendar4',
          buttonText: '+ Create Classes',
          guide: 'https://youtu.be/WdXydJxGFpI',
          videoid: 'UXZpf-wAh-U',
          guideDuration: '0:52',
          dbName: 'setup_widget_progress_klass',
          done: false,
          stepNum: 1
        }
      }
    },
    computed: {
      isSchoolFromNorway () {
        return window.SCHOOL.country.toLowerCase() === 'no'
      },
      isLoading () {
        return this.$store.state.isLoadingSchoolCalenders
      }
    },
    methods: {
      seeTutorial (step) {
        eventbus.youTubeVideoId = step.videoid
        eventbus.isOpenYouTubePopup = true
        this.$emit('tutorial', step)
        if (window.Intercom) {
          window.Intercom('trackEvent', 'Watched tutorial Video planning: ' + step.title)
        }
      }
    }
  }
</script>


<style scoped>

  .bttn {
    display: inline-block !important;
    overflow: initial !important;
  }

  .cals {
    text-align: center;
  }

  .cals_icon {
    font-size: 3.5rem;
    opacity: 0.45;
  }

  h5 {
    line-height: 2rem;
    font-size: 1.2rem;
    text-transform: uppercase;
    opacity: 0.45;
    margin-bottom: 10px;
  }

  h6 {
    font-size: 3.5rem;
    line-height: 3.5rem;
    margin: 10px 0 0;
  }

  .onboard-pill {
    display: flex;
    position: absolute;
    top: 20px;
    right: 0px;
    color: var(--dark-blue);
    align-items: center;
    padding: 2px 10px 2px 5px;
    font-size: 1rem;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }

  .onboard-pill__status {
    font-size: 1rem;
    color: var(--blue);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    align-items: center;
    height: 20px;
    width: 20px;
    border: 1px solid #3ecf8e;
    margin-right: 5px;
  }

  .onboard-pill__status.onboard-pill__status__done {
    background-color: #3ecf8e;
    color: #fff;
    border-color: transparent;
  }

  .text-left {
    text-align: left;
  }

  .step-desc {
    margin-bottom: 10px;
  }

  .submit-button {
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// DashboardBox.vue?87bffd84